import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/api/client';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Client errors (401/403/404/422) will not fix themselves on retry.
        retry: (failureCount, error) =>
          !(error instanceof ApiError && error.status < 500) && failureCount < 2,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Always run: without a network the crew app writes the action to its own offline
        // queue (features/doctor/crewActions.ts), which only happens if the mutation runs;
        // React Query's default would hold it paused in memory, lost with the page. The
        // desk and the office get the network error at once instead of a spinner.
        networkMode: 'always',
      },
    },
  });
}
